import { Button, Layout } from '@tracklib/kit'
import cn from 'clsx'
import styles from 'components/base/loadmorebutton.css'

const LoadMoreButton = ({
  onClick,
  children,
  datatesting,
  noPad,
  disabled,
}: {
  onClick: () => void
  children: JSX.Element | string
  datatesting?: string
  noPad?: boolean
  disabled?: boolean
}) => (
  <Layout.FullWidth className={cn(noPad && styles.noPad)} contentClassName={styles.buttonWrapper}>
    <Button onClick={onClick} datatesting={datatesting} disabled={disabled}>
      {children}
    </Button>
  </Layout.FullWidth>
)

export default LoadMoreButton
